
export const baseStrapiGetFirstParagraphFromBlocks = (blocks: object, wordCount = 30) => {
  if (!blocks) { return null }
  if (typeof blocks !== 'object') { return null }
  const richTextBlock = blocks?.find(i => i?.richText)?.richText
  if (!richTextBlock) { return null }
  const firstParagraph = richTextBlock?.split('</p>')[0]?.replace('<p>', '')?.replace(/(<([^>]+)>)/gi, '')
  if (!firstParagraph) { return null }
  const firstParagraphWords = firstParagraph?.split(/\s+/)
  if (!firstParagraph) { return null }

  const ellipsis = firstParagraphWords?.length > wordCount ? ' …' : ''

  const body = firstParagraphWords?.slice(0, wordCount)?.join(' ')
  return `${body}${ellipsis}`
}
